var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yms-category-tree-panel"},[_c('Tree',{staticClass:"yms-category-tree",attrs:{"data":_vm.treeData,"render":_vm.renderTreeNode,"children-key":"children"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }